export const PORTAL_IMAGE_ACCEPT = '.jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp';
export const MAX_PORTAL_IMAGE_BYTES = 5 * 1024 * 1024;

export const portalImageValidationError = (file) => {
  if (!file) return 'Please choose an image.';
  if (!/\.(jpg|jpeg|png|webp)$/i.test(file.name || '')) {
    return 'Please select a JPG, JPEG, PNG, or WEBP image.';
  }
  if (Number(file.size) === 0) return 'The selected image is empty.';
  if (Number(file.size) > MAX_PORTAL_IMAGE_BYTES) {
    return 'The selected image must be 5 MB or smaller.';
  }
  return '';
};
